module.exports = __webpack_public_path__ + "img/c-02.991243da.jpg";